var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VxWalkthruView',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('VxWalkthruTitle',[_vm._v(" "+_vm._s(_vm.$t("settings.softwareUpdate.title"))+" ")])]},proxy:true}])},[_c('VxWalkthruDescription',[_vm._v(" "+_vm._s(_vm.$t("settings.softwareUpdate.description"))+" ")]),_c('SoftwareUpdateSteps')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }